import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { yieldLazyLoad } from "@devowl-wp/react-utils";
import { extendCommonButtonsStylesheet } from "@devowl-wp/web-cookie-banner";
import { BlockerBody } from "./body/body.js";
import { BlockerFooter } from "./footer/footer.js";
import { BlockerHeader } from "./header/header.js";
import { useBlocker } from "../../contexts/blocker.js";
import { useBlockerStylesheet } from "../../hooks/blocker/useBlockerStylesheet.js";
import { CONTEXT_LATEST_DESIGN_VERSION } from "../../types/commonContext.js";
const YieldBlockerHeader = yieldLazyLoad(Promise.resolve(BlockerHeader));
const YieldBlockerBody = yieldLazyLoad(Promise.resolve(BlockerBody));
const YieldBlockerFooter = yieldLazyLoad(Promise.resolve(BlockerFooter));
const BlockerTextContainer = ({ closeIcon, ...rest })=>{
    const blocker = useBlocker();
    const { designVersion = CONTEXT_LATEST_DESIGN_VERSION, blocker: { visualType, visualThumbnail, name }, texts: { blockerHeadline }, i18n: { skipToConsentChoices } } = blocker;
    const { Inner, Content, InnerBackground, A11ySkipToLink, a11yIds: { firstButton } } = useBlockerStylesheet().extend(...extendCommonButtonsStylesheet);
    const ref = useRef();
    return /*#__PURE__*/ _jsxs(Inner, {
        ref: ref,
        className: "wp-exclude-emoji",
        ...rest,
        children: [
            /*#__PURE__*/ _jsx(A11ySkipToLink, {
                href: `#${firstButton}`,
                "aria-label": `${blockerHeadline.replace(/{{name}}/gi, name)}, ${skipToConsentChoices}`,
                children: skipToConsentChoices
            }),
            visualType === "wrapped" && /*#__PURE__*/ _jsx(InnerBackground, {
                src: visualThumbnail.url,
                alt: visualThumbnail.title,
                "aria-hidden": true
            }),
            /*#__PURE__*/ _jsxs(Content, {
                children: [
                    /*#__PURE__*/ _jsx(YieldBlockerHeader, {
                        closeIcon: closeIcon
                    }),
                    /*#__PURE__*/ _jsx(YieldBlockerBody, {}),
                    designVersion === 1 && /*#__PURE__*/ _jsx(YieldBlockerFooter, {})
                ]
            })
        ]
    });
};
export { BlockerTextContainer };
